// TODO: VL-6033 - re-write the vl_chat FE by FE engineers.

import React from 'react';
import { useCopilotChat } from '@copilotkit/react-core';
import { useVLChatThread } from '../VLChat';
import styles from './style.module.scss';

/**
 * New Chat Button Component
 * Creates a new chat thread using VL Chat context
 * No longer requires props - gets createNewThread from context
 */
const NewChatButton: React.FC = () => {
  const { reset } = useCopilotChat();
  const { createNewThread } = useVLChatThread();

  const handleNewChat = () => {
    // Reset the chat messages
    reset();
    // Create a new thread ID
    createNewThread();
  };

  return (
    <button
      className={styles.newChatButton}
      onClick={handleNewChat}
      title="Start new conversation"
      aria-label="New Chat"
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M10 4V16M4 10H16" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
      <span>New Chat</span>
    </button>
  );
};

export default NewChatButton;